import React from 'react';
import { Typography, useTheme } from '@mui/material';

export const PageTitle: React.FC<{ title: string; 'data-testid'?: string }> = ({
  title,
  'data-testid': dataTestId,
}) => {
  const theme = useTheme();

  return (
    <Typography
      variant='h5'
      sx={{
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightMedium,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        [theme.breakpoints.down('md')]: {
          whiteSpace: 'normal', // Allow wrapping on mobile
          wordBreak: 'break-word',
        },
      }}
      data-testid={dataTestId}
    >
      {title}
    </Typography>
  );
};
